import React from "react";
import Icon from "../assets/Icon";

function Navbar({ config }) {
  return (
    <div className="  w-full">
      {config?.whiteLabelingRequired ? (
        <img
          alt="logo"
          src={config?.whiteLabelingLink}
          className="h-[55px]"
          onError={(e) => {
            e.target.onerror = null; // Prevents infinite loop in case the fallback fails
            e.target.style.display = "none"; // Hides the broken image
            e.target.nextSibling.style.display = "block"; // Shows the default icon
          }}
        />
      ) : (
        <Icon type="hire-logo" width="82" height="70" />
      )}

      <div className="text-center">
        <p className="font-semibold text-[1.875rem] lg:text-[2rem] leading-[2.5rem] pt-8 lg:pt-[0.875rem]">
          Meet World’s most advanced AI Interviewer,{" "}
          <span className="text-[#F79009]"> Maya! </span>
        </p>
      </div>
    </div>
  );
}

export default Navbar;
